(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wellenby-header"] && !Shopify.designMode) return;
  try {
    
class WellenbyAnnouncements extends HTMLElement{connectedCallback(){if(this.dataset.initialized==='true')return;this.dataset.initialized='true';this.track=this.querySelector('.wy-header__announcement-track');this.items=this.querySelectorAll('.wy-header__announcement-item');this.index=0;if(!this.track||this.items.length<2||window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;const interval=Number(this.dataset.interval)||4000;this.timer=window.setInterval(()=>{this.index=(this.index+1)%this.items.length;this.track.style.transform=`translateX(-${this.index*100}%)`},interval)}disconnectedCallback(){window.clearInterval(this.timer)}}
if(!customElements.get('wellenby-announcements'))customElements.define('wellenby-announcements',WellenbyAnnouncements);
class WellenbyHeader extends HTMLElement{connectedCallback(){if(this.dataset.megaInitialized==='true')return;this.dataset.megaInitialized='true';this.shell=this.querySelector('[data-wy-mega-shell]');this.triggers=[...this.querySelectorAll('[data-wy-mega-trigger]')];this.panels=[...this.querySelectorAll('[data-wy-mega-panel]')];this.triggers.forEach(trigger=>{trigger.addEventListener('mouseenter',()=>this.open(trigger.dataset.wyMegaTrigger));trigger.addEventListener('focus',()=>this.open(trigger.dataset.wyMegaTrigger));trigger.addEventListener('click',()=>this.open(trigger.dataset.wyMegaTrigger))});this.querySelector('.wy-header__nav')?.addEventListener('mouseleave',()=>this.scheduleClose());this.shell?.addEventListener('mouseenter',()=>window.clearTimeout(this.closeTimer));this.shell?.addEventListener('mouseleave',()=>this.scheduleClose());this.escapeHandler=event=>{if(event.key==='Escape')this.close()};document.addEventListener('keydown',this.escapeHandler)}open(name){window.clearTimeout(this.closeTimer);this.shell?.classList.add('is-open');this.triggers.forEach(trigger=>trigger.setAttribute('aria-expanded',String(trigger.dataset.wyMegaTrigger===name)));this.panels.forEach(panel=>panel.classList.toggle('is-active',panel.dataset.wyMegaPanel===name))}scheduleClose(){this.closeTimer=window.setTimeout(()=>this.close(),220)}close(){this.shell?.classList.remove('is-open');this.triggers.forEach(trigger=>trigger.setAttribute('aria-expanded','false'));this.panels.forEach(panel=>panel.classList.remove('is-active'))}disconnectedCallback(){window.clearTimeout(this.closeTimer);document.removeEventListener('keydown',this.escapeHandler)}}
if(!customElements.get('wellenby-header'))customElements.define('wellenby-header',WellenbyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wellenby-lifestyle-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = section => {
      if (section.dataset.initialised === 'true') return;
      section.dataset.initialised = 'true';
      if (section.dataset.autoplay !== 'true') return;
      const viewport = section.querySelector('[data-wy-lifestyle-viewport]');
      const slides = section.querySelectorAll('.wy-lifestyle__slide');
      if (!viewport || slides.length < 4) return;
      const pixelsPerSecond = Number(section.dataset.speed) || 24;
      let interacting = false;
      let previousTime = 0;
      const tick = time => {
        if (!previousTime) previousTime = time;
        const elapsed = Math.min(time - previousTime, 50);
        previousTime = time;
        if (!interacting && document.visibilityState === 'visible') {
          viewport.scrollLeft += pixelsPerSecond * elapsed / 1000;
          const resetPoint = viewport.scrollWidth / 2;
          if (viewport.scrollLeft >= resetPoint) viewport.scrollLeft -= resetPoint;
        }
        window.requestAnimationFrame(tick);
      };
      viewport.addEventListener('pointerdown', () => { interacting = true; });
      window.addEventListener('pointerup', () => { interacting = false; previousTime = performance.now(); });
      document.addEventListener('visibilitychange', () => { previousTime = performance.now(); });
      window.requestAnimationFrame(tick);
    };
    document.querySelectorAll('[data-wy-lifestyle]').forEach(initialise);
    document.addEventListener('shopify:section:load', event => {
      const section = event.target.querySelector('[data-wy-lifestyle]');
      if (section) initialise(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wellenby-product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const load = async section => {
      if (section.dataset.loaded === 'true') return;
      section.dataset.loaded = 'true';
      try {
        const response = await fetch(section.dataset.url);
        const text = await response.text();
        const documentFragment = new DOMParser().parseFromString(text, 'text/html');
        const incoming = documentFragment.querySelector('[data-wy-recommendations]');
        if (incoming && incoming.innerHTML.trim()) section.innerHTML = incoming.innerHTML;
      } catch (error) {
        section.dataset.loaded = 'false';
      }
    };
    document.querySelectorAll('[data-wy-recommendations]').forEach(section => {
      if (section.innerHTML.trim()) return;
      if (!('IntersectionObserver' in window)) {
        load(section);
        return;
      }
      const observer = new IntersectionObserver(entries => {
        if (!entries[0].isIntersecting) return;
        observer.disconnect();
        load(section);
      }, { rootMargin: '0px 0px 400px' });
      observer.observe(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
